import { render, staticRenderFns } from "./comment-segmenter-votre-audience-pour-maximiser-limpact-de-vos-instagram-ads.vue?vue&type=template&id=4223eb37&"
import script from "./comment-segmenter-votre-audience-pour-maximiser-limpact-de-vos-instagram-ads.vue?vue&type=script&lang=js&"
export * from "./comment-segmenter-votre-audience-pour-maximiser-limpact-de-vos-instagram-ads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports